/**
 * GENERATED from prototype/index.html.
 * Regenerate with: node tools/gen-data.mjs
 *
 * These are the same numbers prototype/verify.js asserts and the Django
 * seeder loads (backend/apps/game/management/commands/seed_gamedata.py).
 * Do not hand-edit — change the prototype, regenerate, re-run both suites.
 */
import type { CharacterDef, CharacterSlot } from './types';

export const CHARACTERS: readonly CharacterDef[] = [
  {
    key:"jin", name:"Explorer Jin", title:"The Brave Beginner", role:"Balanced",
    slot:"explorer", stars:3, icon:"🧑‍🔧", accent:"#F5C542",
    bonus:"mining_speed", value:5, label:"+5% Mining Speed",
    special:"lucky_start", specialName:"Lucky Start",
    specialDesc:"First rock of each descent is Uncommon or better — but never one your axe cannot break.",
    desc:"A young and energetic explorer who dreams of discovering the endless treasures of the cave.",
    costCoins:0, costKyat:null,
  },
  {
    key:"luna", name:"Luna Lightbringer", title:"The Lamp Specialist", role:"Support",
    slot:"explorer", stars:4, icon:"🧝‍♀️", accent:"#A96BF0",
    bonus:"lamp_glow", value:25, label:"+25% Lamp Brightness",
    special:"see_hidden_paths", specialName:"See Hidden Paths",
    specialDesc:"Cracked walls glow before you search, and finds rise from 10% to 18%.",
    desc:"A mysterious girl who can light up the darkest places and reveal hidden secrets.",
    costCoins:25000, costKyat:null,
  },
  {
    key:"thor", name:"Thor Grimaxe", title:"The Power Miner", role:"Damage",
    slot:"explorer", stars:4, icon:"🧔", accent:"#E0553F",
    bonus:"axe_damage", value:20, label:"+20% Axe Damage",
    special:"critical_master", specialName:"Critical Master",
    specialDesc:"Crit chance x1.5, and each crit hits for 2.6x instead of 2.2x.",
    desc:"A strong and fearless miner who breaks the toughest rocks with pure power.",
    costCoins:80000, costKyat:null,
  },
  {
    key:"mira", name:"Mira Treasureseeker", title:"The Treasure Hunter", role:"Lucky",
    slot:"explorer", stars:4.5, icon:"👩‍🌾", accent:"#5CCB6A",
    bonus:"treasure_chance", value:15, label:"+15% Treasure Chance",
    special:"double_loot", specialName:"Double Loot Chance",
    specialDesc:"12% chance a broken rock yields two items instead of one.",
    desc:"An adventurous hunter with incredible luck in finding rare treasures and valuable items.",
    costCoins:200000, costKyat:null,
  },
  {
    key:"rocky", name:"Rocky", title:"The Loyal Companion", role:"Companion",
    slot:"companion", stars:2.5, icon:"🦫", accent:"#C99A6A",
    bonus:"auto_collect", value:10, label:"+10% Auto-Collect",
    special:"finds_extra", specialName:"Finds Extra Items",
    specialDesc:"8% chance to dig up a bonus trash item. Never skips a Shwe Kyat ad.",
    desc:"A loyal little mole who loves mining and helps you collect extra items automatically.",
    costCoins:60000, costKyat:null,
  },
  {
    key:"sakura", name:"Sakura", title:"The Legendary Explorer", role:"Legendary",
    slot:"explorer", stars:5, icon:"🌸", accent:"#FF8FC0",
    bonus:"all_rewards", value:30, label:"+30% All Rewards",
    special:"sakura_blessing", specialName:"Sakura Blessing",
    specialDesc:"The first Star Stone or Shwe Stone each descent costs half its HP.",
    desc:"A legendary explorer blessed by the Sakura Spirit. Her presence brings fortune.",
    costCoins:null, costKyat:150,
  },
] as const;

export const CHARACTER: Readonly<Record<string, CharacterDef>> = Object.freeze(
  Object.fromEntries(CHARACTERS.map((c) => [c.key, c])),
);

/** Coins only. Kyat's job is to be withdrawn, not burned on upgrades. */
export const CHARACTER_UPGRADE_COSTS: readonly (number | null)[] =
  [null, 5000, 12000, 24000, 40000, 80000, 140000, 240000, 400000, 1000000] as const;

/** +6%/level for 2-5, +8% for 6-9, +10% at 10 — of the BASE bonus. */
export function characterLevelMultiplier(level: number): number {
  let m = 1;
  for (let i = 2; i <= level; i++) m += i <= 5 ? 0.06 : i <= 9 ? 0.08 : 0.10;
  return m;
}

export const bySlot = (slot: CharacterSlot): readonly CharacterDef[] =>
  CHARACTERS.filter((c) => c.slot === slot);
